import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrevisioniRoutingModule } from './previsioni-routing.module';
import { PrevisioniComponent } from './previsioni.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NbCardModule, NbLayoutModule, NbTabsetModule } from '@nebular/theme';

@NgModule({
  imports: [
    CommonModule,
    PrevisioniRoutingModule,
    NgbModule,
    NbLayoutModule,
    NbTabsetModule,
    NbCardModule,
    
  ],
  declarations: [PrevisioniComponent],
  exports:[PrevisioniComponent],
})
export class PrevisioniModule { }
